module.exports = __webpack_public_path__ + "static/media/MediaGroup_Ucraina.b6b513f6.png";